import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function useCollapsed(key: string) {
  const { user } = useAuth() as any;
  const storeKey = `sl_collapsed_${user?.id || "anon"}`;
  const read = () => { try { return JSON.parse(localStorage.getItem(storeKey) || "{}"); } catch { return {}; } };
  const [collapsed, setC] = useState<boolean>(() => !!read()[key]);
  const toggle = () => { const next = !collapsed; setC(next); localStorage.setItem(storeKey, JSON.stringify({ ...read(), [key]: next })); };
  return { collapsed, toggle };
}

export function CollapseToggle({ collapsed, onToggle, testid }: { collapsed: boolean; onToggle: () => void; testid: string }) {
  return (
    <button type="button" data-testid={testid} aria-expanded={!collapsed} title={collapsed ? "Expand" : "Collapse"} onClick={onToggle} className="rounded p-1 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-900">
      <ChevronDown size={16} className={`transition-transform ${collapsed ? "-rotate-90" : ""}`} />
    </button>
  );
}
